import { IQuery, Topics } from '@zaplify/common';
import { GroupStatisticsDto } from '../dtos';

export class GetMessageStatisticsQuery extends IQuery<Record<string, GroupStatisticsDto>> {
    public static override readonly TOPIC = Topics.CAMPAIGNS;
    constructor(readonly userId: string, readonly groupIds: string[], readonly sinceTimestamp?: number) {
        super();
    }
}
